import axiosInstance from '../../services/axios/axios';
import { then } from '../../services/axios/_utility';

export const getPendingApprovalsForApprover = approverEsoId => {
	return axiosInstance
		.get(
			`api/Applications/Requests/PendingApprovals?approverEsoId=${approverEsoId}`
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};

export const processPendingApprovalsRequest = requests => {
	return axiosInstance
		.patch('api/Applications/Requests/PendingApprovals', requests)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};
